<div class="profile-menu">
  @if(showHeader()){
    <div class="profile-menu__header">
      <h3 >Profile</h3>
      <button  matButton class="profile-menu__close-icon" (click)="profileClosed.emit()">
        <i class="icon-close"></i>
      </button>
    </div>
  }

  <div class="profile-menu__username">
    <span class="profile-menu__icon">
      <mat-icon svgIcon="user"></mat-icon>
    </span>
    @if (profileStore.loading()) {
      <span class="skeleton profile-menu-email-skeleton"></span>
    } @else {
      <span>{{ profileStore.email() }}</span>
    }
  </div>

  <mat-divider class="w-full"></mat-divider>

  <button matButton  class="profile-menu__item !cursor-pointer" (click)="logout()">
    <mat-icon svgIcon="logout"></mat-icon>
    <span>Sign out</span>
  </button>
</div>
